import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { element } from 'prop-types';


const SuperMostAdminDashboard = Loadable(lazy(() => import('views/SuperMostAdmin/Default')));
const SuperMostAdminGatePass = Loadable(lazy(() => import('views/SuperMostAdmin/GatePass')));
const SuperMostAdminStudentManagement = Loadable(lazy(() => import('views/SuperMostAdmin/Student_Management')));
const SuperMostAdminComplaintManagement = Loadable(lazy(() => import('views/SuperMostAdmin/Complaint_Management')));
const SuperMostAdminRoomAllocation = Loadable(lazy(() => import('views/SuperMostAdmin/Room_Allocation')));
const SuperMostAdminBuildingManagement = Loadable(lazy(() => import('views/SuperMostAdmin/Building_Management')));
const SuperMostAdminBookingRequest = Loadable(lazy(() => import('views/SuperMostAdmin/Booking_Request')));
const SuperMostAdminStudentAttendance = Loadable(lazy(() => import('views/SuperMostAdmin/StudentAttendance')));
const SuperMostAdminRoomAllotment = Loadable(lazy(() => import('views/SuperMostAdmin/Room_Allotment/page')));
const SuperMostAdminReports = Loadable(lazy(() => import('views/SuperMostAdmin/Reports')));
const SuperMostAdminStudentDetails = Loadable(lazy(() => import('views/SuperMostAdmin/Student_Management/Student_details')));
const AuditLog = Loadable(lazy(() => import('views/SuperMostAdmin/AuditLog')));
const RoleManagement = Loadable(lazy(() => import('views/SuperMostAdmin/RoleManagement')));
const HospitalComplaint = Loadable(lazy(() => import('views/SuperMostAdmin/Hospital_Complaint')));
const Department = Loadable(lazy(() => import('views/SuperMostAdmin/Department')));
const WhatsAppAudit =Loadable(lazy(() => import('views/SuperMostAdmin/WhatsAppAudit')));
const BiometricLog = Loadable(lazy(()=> import('views/SuperMostAdmin/BiometricLog')));
const StudentFeeManagement = Loadable(lazy(()=> import('views/SuperMostAdmin/StudentFee_Managment')));
const FeeApproval = Loadable(lazy(()=> import('views/SuperMostAdmin/FeeApproval')));
const FeeReports = Loadable(lazy(() => import('views/SuperMostAdmin/FeeReports')));
const ComplainCategoryManagement = Loadable(lazy(() => import('views/SuperMostAdmin/ComplainCategoryManagement')));
const FeeUpload = Loadable(lazy(() => import('views/SuperMostAdmin/FeeUpload')));
const DevicePhotoUpload = Loadable(lazy(() => import('views/SuperMostAdmin/DevicePhotoUpload')));
const DeviceUploadManager = Loadable(lazy(() => import('views/SuperMostAdmin/DeviceUploadManager')));
const UgDoorMgtSystem = Loadable(lazy(() => import('views/SuperMostAdmin/UgDoorMgtSystem')));

const MessUnifiedReport = Loadable(lazy(() => import('views/SuperMostAdmin/Mess/MessReport/index')));
const MessStudentStaffReport = Loadable(lazy(() => import('views/SuperMostAdmin/Mess/index')));
const MessCard = Loadable(lazy(() => import('views/SuperMostAdmin/Mess/MessCard/index')));
const MessStaff = Loadable(lazy(() => import('views/SuperMostAdmin/Mess/MessStaff/index')));

// Course Management
// const SuperMostAdminCollege = Loadable(lazy(() => import('views/SuperMostAdmin/Coures_Managment/college')));
// const SuperMostAdminCourse = Loadable(lazy(() => import('views/SuperMostAdmin/Coures_Managment/course')));



const SuperMostAdminRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <SuperMostAdminDashboard />
    },
    {
      path: 'supermostadmin',
      children: [
        {
          path: 'default',
          element: <SuperMostAdminDashboard />
        },
        {
          path: 'studentmanagement/studentdetails/:id',
          element: <SuperMostAdminStudentDetails />
        },
        {
          path: 'buildingmanagement',
          element: <SuperMostAdminBuildingManagement />
        },
        {
          path: 'studentmanagement',
          element: <SuperMostAdminStudentManagement />
        },
        {
          path: 'ComplainCategoryManagement',
          element: <ComplainCategoryManagement/>
        },
        {
          path: 'studentfeemanagement',
          element: <StudentFeeManagement />
        },
        {
          path: 'FeeApproval',
          element: <FeeApproval />
        },
        {
          path: 'feeupload',
          element: <FeeUpload />
        },
        {
          path: 'FeeReports',
          element: <FeeReports />
        },
        {
          path: 'complaintmanagement',
          element: <SuperMostAdminComplaintManagement />
        },
        {
          path: 'studentattendance',
          element: <SuperMostAdminStudentAttendance />
        },
        {
          path: 'roomallotment',
          element: <SuperMostAdminRoomAllotment />
        },
        {
          path: 'roomallocation',
          element: <SuperMostAdminRoomAllocation />
        },
        {
          path: 'booking_request',
          element: <SuperMostAdminBookingRequest />
        },
        {
          path: 'reports',
          element: <SuperMostAdminReports />
        },

        {
          path: 'superAdminGatePass',
          element: <SuperMostAdminGatePass />
        },
        {
          path: 'roleManagement',
          element: <RoleManagement/>,
        },
        {
          path: 'auditLog',
          element: <AuditLog/>
        },
        {
          path: 'DevicePhotoUpload',
          element: <DevicePhotoUpload />
        },
         {
          path: 'DeviceUploadManager',
          element: <DeviceUploadManager />
        },
        {
          path: 'UgDoorMgtSystem',
          element: <UgDoorMgtSystem />
        },
        {
          path: 'hospital_complaint',
          element: <HospitalComplaint />
        },
        {
          path: 'department',
          element: <Department />
        },
        {
          path: 'WhatsAppAudit',
          element: <WhatsAppAudit />
        },
        {
          path: 'biometriclog',
          element: <BiometricLog />
        },
        // {
        //   path: 'college',
        //   element: <SuperMostAdminCollege />
        // },
        // {
        //   path: 'course',
        //   element: <SuperMostAdminCourse />
        // },
        // {
        //   path: 'coursemanagement',
        //   element: <SuperMostAdminCollege />
        // },
        {
          path: 'mess/card',
          element: <MessCard />
        },
        {
          path: 'mess/staff',
          element: <MessStaff />
        },
        {
          path: 'mess/student-staff-report',
          element: <MessStudentStaffReport />
        },
        {
          path: 'mess/student-staff',
          element: <MessStudentStaffReport />
        },
        {
          path: 'mess/reports',
          element: <MessUnifiedReport />
        },
        {
          path: 'mess/report',
          element: <MessUnifiedReport />
        },
        {
          path: 'mess',
          element: <MessUnifiedReport />
        }
      ]
    }
  ]
};

export default SuperMostAdminRoutes;
